// const firebaseConfig = {
//   apiKey: "AIzaSyBV1o8iW_TmejeDlqPjy2Q5Q89Z9M8QwzE",

//   authDomain: "iman-xpress.firebaseapp.com",

//   projectId: "iman-xpress",

//   storageBucket: "iman-xpress.appspot.com",

//   messagingSenderId: "1079505892162",

//   appId: "1:1079505892162:web:eb6e930f9029e20d0e4edb",

//   measurementId: "G-NBH3205DYH",
// };

const firebaseConfig = {
  apiKey: "AIzaSyDU8Ywfm9vQgoAAEjZmCRruPBOUG69W_Ak",
  authDomain: "iman-xpress-9b3a9.firebaseapp.com",
  projectId: "iman-xpress-9b3a9",
  storageBucket: "iman-xpress-9b3a9.appspot.com",
  messagingSenderId: "144183995132",
  appId: "1:144183995132:web:040760de5f1989c4354579"
};

export default firebaseConfig;
